export var StandardErrorCodes;
(function (StandardErrorCodes) {
    StandardErrorCodes["AUTHENTICATION_FAILED"] = "AUTHENTICATION_FAILED";
    StandardErrorCodes["AUTHORIZATION_FAILED"] = "AUTHORIZATION_FAILED";
    StandardErrorCodes["RESOURCE_NOT_FOUND"] = "RESOURCE_NOT_FOUND";
})(StandardErrorCodes || (StandardErrorCodes = {}));
export class RouteError extends Error {
    error;
    constructor(error) {
        super(error.code);
        this.error = error;
    }
    get responseStatusCode() {
        return this.error.response_code || 500;
    }
}
export class AuthenticationError extends RouteError {
    constructor() {
        super({
            code: StandardErrorCodes.AUTHENTICATION_FAILED,
            response_code: 401
        });
    }
}
export class AuthorizationError extends RouteError {
    constructor(options) {
        super({
            code: StandardErrorCodes.AUTHORIZATION_FAILED,
            human_error: options?.human_error,
            response_code: 403
        });
    }
}
export class ResourceError extends RouteError {
    constructor(options) {
        const label = options.resource_type.charAt(0).toUpperCase() + options.resource_type.slice(1);
        super({
            code: StandardErrorCodes.RESOURCE_NOT_FOUND,
            human_error: `${label} with id: [${options._id.toString()}] not found`,
            response_code: 404
        });
    }
}
export class ValidationError extends RouteError {
    constructor(options) {
        super({
            code: options.code,
            human_error: options.human_error,
            response_code: 422
        });
    }
}
